import { useCadencedTime } from './time-hooks';
import { getTimeSimplifiedDurationFn } from './time-utils';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import TimerIcon from '@material-ui/icons/Timer';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
var iconTypeMap = {
    current: PlayArrowIcon,
    past: PauseIcon,
    future: TimerIcon
};
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        current: {
            color: palette.variables.actionTime
        },
        past: {},
        future: {}
    });
});
export var TurnIcon = function (props) {
    var classes = useStyles();
    var getDuration = getTimeSimplifiedDurationFn(props, 0);
    var iconType = useCadencedTime(function (time) {
        var duration = getDuration(time);
        if (duration === props.duration) {
            return 'future';
        }
        if (duration === 0) {
            return 'past';
        }
        return 'current';
    });
    var Icon = iconTypeMap[iconType];
    return React.createElement(Icon, { className: classes[iconType], fontSize: 'inherit' });
};
